/**
 * Session token storage. The Google OAuth callback drops a signed
 * session token into the URL fragment; the frontend extracts it once
 * on `/login/callback`, stashes it here, and sends it as
 * `Authorization: Bearer <token>` on every API call thereafter.
 *
 * localStorage is fine for an operator console: XSS-on-our-own-app is
 * the only way to leak it, and we control all our own code. For
 * customer-facing apps we'd use an HttpOnly cookie instead.
 */

const KEY = 'nv:auth:token';

export function getToken(): string {
  try {
    return localStorage.getItem(KEY) || '';
  } catch {
    return '';
  }
}

export function setToken(token: string): void {
  try {
    if (token) localStorage.setItem(KEY, token);
    else localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}

export function clearToken(): void {
  setToken('');
}
